import axios from 'axios';

export const homepage_api = axios.create({
  baseURL: 'http://127.0.0.1:5000/api/homepage',
  headers: {
    Accept: 'application/json',
  },
});
